import React, { Component } from 'react';
const $ = require('jquery');
class EstimateVariance extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            break_status: null,
            break_time: null,
        }
    }
    
    componentDidMount(){
    }

    
    
    render() {
        return (
            <div className="card p-3 m-3">
                    <iframe src="https://crm.kimshospitals.com:3001/d/a6a22481-69bb-43fd-9703-a9c63e9700a6/estimate-variance?orgId=1&var-unit=All&var-min=0&var-max=0&var-avgThreshold=2&var-orderby=Estimated&theme=light" width="100%" height="600" frameborder="0"></iframe>
            </div>

        )

    }
}
export default EstimateVariance;